import {
  Spacer,
  TitleCell,
  TitleRow
} from '../../../../components/ReusableComponents/Table'

const PMSBEHealthTitleRow = () => (
  <TitleRow style={{ position: 'sticky', top: 70 }}>
    <TitleCell>Id</TitleCell>
    <TitleCell>Hotel name</TitleCell>
    <Spacer />
    <TitleCell>CSM</TitleCell>
    <TitleCell textAlign="center">PMS Sync</TitleCell>
    <TitleCell>Last SYNC</TitleCell>
    <TitleCell>
      Reports for <br /> last 48h
    </TitleCell>
    <TitleCell>PMS</TitleCell>
    <TitleCell>Last result</TitleCell>
    <Spacer />
    <Spacer />
    <TitleCell>Notes</TitleCell>
  </TitleRow>
)

export default PMSBEHealthTitleRow
